'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

// Fait apparaître les blocs de texte de <main> quand ils entrent à l'écran (styles dans globals.css).
// Sans JavaScript ou avec « réduire les animations », tout reste affiché normalement.
const SELECTOR = 'main :is(h1, h2, h3, p, li, dl > div, form)';

export default function ScrollReveal() {
    const pathname = usePathname();

    useEffect(() => {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        // Le hero a sa propre entrée ; un bloc déjà animé n'anime pas ses enfants.
        // querySelectorAll suit l'ordre du document : un parent est marqué avant ses enfants.
        const els: HTMLElement[] = [];
        for (const el of document.querySelectorAll<HTMLElement>(SELECTOR)) {
            if (el.closest('.sh-root') || el.parentElement?.closest('[data-reveal]')) continue;
            el.dataset.reveal = 'wait';
            els.push(el);
        }

        const io = new IntersectionObserver(
            (entries) => {
                entries
                    .filter((e) => e.isIntersecting)
                    .forEach((e, i) => {
                        const el = e.target as HTMLElement;
                        io.unobserve(el);
                        el.style.setProperty('--reveal-delay', `${i * 70}ms`);
                        el.dataset.reveal = 'in';
                        // on rend la main aux transitions propres de l'élément une fois l'entrée finie
                        setTimeout(() => {
                            delete el.dataset.reveal;
                            el.style.removeProperty('--reveal-delay');
                        }, 900 + i * 70);
                    });
            },
            { rootMargin: '0px 0px -8% 0px' },
        );
        els.forEach((el) => io.observe(el));

        return () => {
            io.disconnect();
            els.forEach((el) => delete el.dataset.reveal);
        };
    }, [pathname]);

    return null;
}
